module.exports = __webpack_public_path__ + "img/img1.4dceaa6c.png";